<script setup lang="ts">
import { Form, Head, Link } from "@inertiajs/vue3";

import AuthCardShell from "@/components/auth-card-shell.vue";
import { Button } from "@/components/ui/button/index";
import { sessionsPasswordlessPath, signInPath } from "@/routes";

defineOptions({ inheritAttrs: false });
</script>

<template>
  <Head title="Ingresar con enlace mágico" />

  <AuthCardShell
    title="Ingresar con enlace mágico"
    description="Ingresá tu email y te vamos a enviar un enlace seguro para entrar."
  >
    <Form
      :action="sessionsPasswordlessPath()"
      method="post"
      disable-while-processing
      class="inert:pointer-events-none inert:opacity-80"
      #default="{ errors, processing }"
    >
      <div class="space-y-4">
        <div class="space-y-1.5">
          <label for="passwordless-email" class="text-sm font-medium">Correo electrónico</label>
          <input
            id="passwordless-email"
            name="email"
            type="email"
            required
            autocomplete="email"
            inputmode="email"
            placeholder="correo@ejemplo.com"
            class="input-field"
          />
          <p v-if="errors.email" class="text-sm text-destructive">
            {{ errors.email }}
          </p>
        </div>

        <Button type="submit" :disabled="processing" class="h-11 w-full text-base sm:h-10 sm:text-sm">
          {{ processing ? "Enviando..." : "Enviar enlace mágico" }}
        </Button>
      </div>
    </Form>

    <p class="mt-6 text-center text-sm text-muted-foreground">
      ¿Preferís usar tu contraseña?
      <Link
        :href="signInPath()"
        class="font-medium text-foreground underline-offset-4 hover:underline"
      >Volver a iniciar sesión</Link>
    </p>
  </AuthCardShell>
</template>
